import script from "./OrganizationLimitsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrganizationLimitsSection.vue?vue&type=script&setup=true&lang=ts"

import "./OrganizationLimitsSection.vue?vue&type=style&index=0&id=2a2f3baa&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a2f3baa"]])

export default __exports__